module.exports = __webpack_public_path__ + "static/img/a16.ba46770.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/a16.jpg
// module id = 434
// module chunks = 1